(function () {
    'use strict';

    angular
        .module('LayoutBuilder')
        .directive('lbSidebarContent', lbSidebarContent);

    function lbSidebarContent() {
        return {
            restrict: 'E',
            templateUrl: 'common/libraries/layoutBuilder/panels/sidebar-content'
        };
    }
})();